var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{class:_vm.$vuetify.breakpoint.mdAndUp ? '' : 'mobile'},[_vm._t("snackbar"),_vm._t("header"),_vm._t("drawer"),_c('v-main',[_vm._t("default")],2),_vm._t("footer")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }